import { Grid, makeStyles, TextField } from "@material-ui/core";
import { FormSpacer } from "@saleor/components/FormSpacer";
import React from "react";

interface HomeLocationSectionProps {
  formData: any;
  onChange: any;
  rider?: any;
  disableLatLong?: boolean;
}

const useStyles = makeStyles(
  () => ({
    container: {
      margin: "17px 0"
    },
    inputLabels: {
      color: "black",
      marginBottom: "5px"
    },
    spacer: {
      marginTop: "15px"
    }
  }),
  { name: "HomeLocationSection" }
);

function HomeLocationSection(props: HomeLocationSectionProps) {
  const classes = useStyles(props);
  const { formData, onChange, disableLatLong } = props;

  return (
    <div className={classes.container}>
      <Grid container spacing={1}>
        <Grid item xs={12} sm={12} md={12}>
          <TextField
            label="Latitude"
            id="txtOrderAssignRiderDialogPickupLat"
            variant="outlined"
            name="pickupLatitude"
            value={formData?.pickupLatitude}
            onChange={onChange}
            fullWidth
            disabled={disableLatLong}
          />
        </Grid>
      </Grid>
      <FormSpacer spacing={1} />
      <Grid container spacing={1}>
        <Grid item xs={12} sm={12} md={12}>
          <TextField
            label="Longitude"
            id="txtOrderAssignRiderDialogPickupLong"
            variant="outlined"
            name="pickupLongitude"
            value={formData?.pickupLongitude}
            onChange={onChange}
            fullWidth
            disabled={disableLatLong}
          />
        </Grid>
      </Grid>
    </div>
  );
}

export default HomeLocationSection;
